/**
 * @generated SignedSource<<255b47cc0babd2dc6c2822562386643c>>
 * @relayHash 4cef641aeddb35300aa8d4846416dd5c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15c35c8f3c86832753921d0da0dad55d8b9e763158ce0f0a3976cf1897ea1a8b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { uiSupportWebsiteCustomPagesQuery } from './uiSupportWebsiteCustomPagesQuery.graphql';

const node: PreloadableConcreteRequest<uiSupportWebsiteCustomPagesQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "15c35c8f3c86832753921d0da0dad55d8b9e763158ce0f0a3976cf1897ea1a8b",
    "metadata": {
      "connection": [
        {
          "count": "NUMBER_OF_PAGES_INITIAL_FETCH",
          "cursor": null,
          "direction": "forward",
          "path": [
            "helpCenter",
            "helpCenterPages"
          ]
        }
      ]
    },
    "name": "uiSupportWebsiteCustomPagesQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
